import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Hero/Hero";
import Carousel from "../components/Carousel/Carousel";
import Footer from "../components/Footer/Footer";
import Paragraph from "../components/Paragraphs/Paragraph";

function About() {
  const images = [
    "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1280px-React-icon.svg.png",
    "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/1200px-Python-logo-notext.svg.png",
    "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/1280px-Unofficial_JavaScript_logo_2.svg.png",
    "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/C_Sharp_wordmark.svg/1200px-C_Sharp_wordmark.svg.png",
    "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Git_icon.svg/1024px-Git_icon.svg.png",
    "https://gitlab.com/gitlab-com/gitlab-artwork/-/raw/master/logo/logo-square.png",
    "https://fastapi.tiangolo.com/img/logo-margin/logo-teal.png",
    "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Apache_Software_Foundation_Logo_%282016%29.svg/1280px-Apache_Software_Foundation_Logo_%282016%29.svg.png",
    "https://www.w3.org/html/logo/downloads/HTML5_Logo_512.png",
    "https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_1280.png",
    "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Android_Studio_Icon_3.6.svg/1900px-Android_Studio_Icon_3.6.svg.png",
  ];

  return (
    <>
      <Navbar />
      <Hero
        cName="hero-mid"
        src="https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
        alt="image code"
        type="img"
        title="About Me"
        btnClass="hide"
      />
      <Paragraph />
      <Carousel images={images} interval={2000} zoom={true} />
      <br />
      <Footer />
    </>
  );
}

export default About;
